import { useEffect } from 'react';
import { Resources } from '@/src/shared/constants/resources';
import { UserFields, UserRoles } from '@/src/shared/constants/users';
import { useGetIdentity } from 'ra-core';
import { useRedirect } from 'react-admin';
import { useLocation } from 'react-router-dom';

type RedirectBillingIfNoSubscriptionProps = {
  isEmployee?: boolean;
};

const RedirectBillingIfNoSubscription = (props: RedirectBillingIfNoSubscriptionProps) => {
  const sx = {};
  const redirect = useRedirect();
  const { pathname } = useLocation();
  const { data: user } = useGetIdentity();

  // Check if user has clubAdmin role
  const isSubscribed = user?.[UserFields.Roles]?.includes(UserRoles.ClubAdmin);

  useEffect(() => {
    if (!props.isEmployee) {
      if (user && !isSubscribed && !pathname.includes(`/${Resources.Billing}`)) {
        redirect('list', Resources.Billing);
      }
    }
  }, [pathname, user?.id, isSubscribed]);

  return null;
};

export default RedirectBillingIfNoSubscription;
